module.exports = __webpack_public_path__ + "assets/splunk_large_logo.png";